import React from 'react'

class Numbers extends React.Component{
    render(){
     return(
            <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 md:col-span-4 bg-white shadow p-5 rounded-lg hover:bg-pink-600 hover:text-white">
                    <div className="flex justify-between items-center">
                        <p className="text-6xl font-extrabold">100+</p>
                        <p className="text-3xl text-right leading-tight">Projects</p>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-4 bg-white shadow p-5 rounded-lg hover:bg-pink-600 hover:text-white text-as">
                    <div className="flex justify-between items-center">
                        <p className="text-6xl font-extrabold">75+</p>
                        <p className="text-3xl text-right leading-tight">Worked<br />Locations</p>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-4 bg-white shadow p-5 rounded-lg hover:bg-pink-600 hover:text-white">
                    <div className="flex justify-between items-center">
                        <p className="text-6xl font-extrabold">100+</p>
                        <p className="text-3xl text-right leading-tight">Working Members</p>
                    </div>
                </div>
            </div>
     );   
    }
}

export default Numbers;


// WEBPACK FOOTER //
// ./src/components/numbers.jsx